<template>
  <f7-page class="main-weighing-system">
    <template #fixed>
      <TheNavbar
        :style="appTheme"
        :nav-title="$t('production.weighingSystem.title')"
        back-btn-enable
        :qr-btn-enable="paleAPesar != null"
        @qr-btn="EventOpenCodeSearch"
      >
        <template #btn-right>
          <img
            v-if="paleAPesar != null"
            src="@/static/icons/ic_print.svg"
            width="37"
            class="padding-left-half"
            @click="PrintPalletLabel()"
          >
        </template>
      </TheNavbar>
    </template>

    <div :class="paleAPesar == null ? 'content-nodata' : 'content-data'">
      <UCEmptyList
        v-if="paleAPesar == null"
        class="content-nodata"
        icon="./static/icons/code-green.svg"
        :title="$t('production.weighingSystem.noData.title')"
        :subtitle="$t('production.weighingSystem.noData.subtitle')"
      />

      <div v-else>
        <div class="content-main-data">
          <f7-block class="content-main-data__data">
            <span class="content-title">
              {{ $t('production.weighingSystem.labels.serialNumber') }}
            </span>
            <span class="content-subtitle"> {{ paleAPesar.NumeroSerie }}</span>
            <span class="content-title">
              {{ $t('production.weighingSystem.labels.manufactureDate') }}
            </span>
            <span class="content-subtitle"> {{ FormatDate(paleAPesar.FechaFabricacion) }}</span>
          </f7-block>
          <f7-block class="content-main-data__data">
            <span class="content-title">
              {{ $t('production.weighingSystem.labels.grossWeight.text') }}
            </span>
            <span class="content-subtitle">
              {{ `${pesoBrutoTotal} ${$t('common.kg')}` }}
            </span>
            <span class="content-title">
              {{ $t('production.weighingSystem.labels.totalPackages') }}
            </span>
            <span class="content-subtitle"> {{ numeroEnvasesTotal }} </span>
          </f7-block>
        </div>
        <div class="content-data-list">
          <f7-list
            v-for="(existencia, i) in paleAPesar.Existencias"
            :key="i"
            media-list
          >
            <f7-list-item
              v-for="(exist, j) in existencia"
              :key="j"
            >
              <template #title>
                <div class="item-title-row">
                  <span class="item-title"> {{ exist[0].Articulo.Nombre }} </span>
                </div>
              </template>

              <template #subtitle>
                <div>
                  <span class="item-subtitle"> {{ exist[1].Articulo.Nombre }} </span>
                </div>
              </template>

              <div
                class="content-list-logistic"
              >
                <div class="display-flex">
                  <img
                    alt="iconBox"
                    src="@/static/icons/ic_box.svg"
                  >
                  <span class="display-flex align-items-center">
                    <span class="content-list-logistic__number">
                      {{ exist[1].Cantidad }}
                    </span> {{ $t('common.packages').toLowerCase() }}
                  </span>
                </div>
                <span>
                  <span class="content-list-logistic__number">
                    {{
                      exist[0].PesoBruto !== 0
                        ? exist[0].PesoBruto
                        : exist[0].Cantidad
                    }}
                  </span> {{ $t('production.weighingSystem.labels.grossWeightKg') }}
                </span>
              </div>
            </f7-list-item>
          </f7-list>
        </div>
      </div>
    </div>

    <UCCodeScanner
      ref="componentUCcodeScanner"
      :text-button="$t('common.scan')"
      :fab-button-show="paleAPesar == null"
      :allow-manual-code-entry="true"
      :auto-open-camera="true"
      @codigo-barras="BarCodeReadingEvent"
      @numero-serie="EventNumeroSerieReading"
      @code-reading="BarCodeReadingEvent"
    />

    <div
      v-if="paleAPesar != null"
      class="content-button"
    >
      <f7-button
        fill
        class="content-button__weighing"
        @click="actionsWeighingReading = true"
      >
        {{ $t('production.weighingSystem.btnPerformWeighing') }}
      </f7-button>
    </div>
    <PCSistemaPesado
      :open-weighing-reading="actionsWeighingReading"
      :weight="pesoBrutoTotal"
      :id-a-n-s="paleAPesar != null ? paleAPesar.Id : 0"
      @event-close="actionsWeighingReading = false"
      @update-weight="UpdateData()"
    />
  </f7-page>
</template>

<script>
import TheNavbar from '@/components/TheNavbar.vue';
import { Log, LogError } from '@/js/common/HIDebuggingSupport';
import UCEmptyList from '@/components/common/UCEmptyList.vue';
import { HiDialog, HiNotification, PreloaderGH } from '@/js/common/HINotificationSupport';
import UCCodeScanner from '@/components/common/UCCodeScanner.vue';
import ConexionTA from '@/js/services/traceability/APITraceability';
import SoporteFechaYHora from '@/js/common/HIConversionSupport';
import PCSistemaPesado from '@/components/production/traceability/PCSistemaPesado.vue';

export default {
  name: 'FrmWeighingSystem',
  components: {
    TheNavbar,
    UCCodeScanner,
    UCEmptyList,
    PCSistemaPesado,
  },
  data() {
    return {
      paleAPesar: null,
      numeroEnvasesTotal: 0,
      pesoBrutoTotal: 0,
      actionsWeighingReading: false,
    };
  },
  computed: {
    appTheme() {
      return {
        '--f7-navbar-bg-color': 'var(--his-slate-blue)',
      };
    },
  },
  methods: {
    FormatDate(fecha) {
      Log(this, this.FormatDate.name);
      return SoporteFechaYHora.ObtenerDiaMesAno(fecha);
    },
    CalculateContainersAndTotalGrossWeight(existencias) {
      Log(this, this.CalculateContainersAndTotalGrossWeight.name);
      existencias.forEach((l) => {
        if (l.Articulo.TipoArticulo === 'Envase') {
          this.numeroEnvasesTotal += l.Cantidad;
        }
        if (l.Articulo.TipoArticulo === 'Producto') {
          this.pesoBrutoTotal += l.PesoBruto !== 0 ? l.PesoBruto : l.Cantidad;
        }
      });
    },

    FilterArray(paleLeido) {
      Log(this, this.FilterArray.name);
      const resultadoFinal = [];
      // cogemos los producto y envase
      const existencias = paleLeido.Existencias.filter((f) => f.Articulo.TipoArticulo === 'Producto' || f.Articulo.TipoArticulo === 'Envase');

      // agrupamos por partida
      const agrupadoPorPartida = existencias.reduce((resultado, item) => {
        const idPartida = item.Partida.Id;
        const grupoExistente = resultado.find((grupo) => grupo.idPartida === idPartida);

        if (grupoExistente) {
          grupoExistente.items.push(item);
        } else {
          resultado.push({
            idPartida,
            items: [item],
          });
        }
        return resultado;
      }, []);

      // dentro de la partida, agrupamos por producto/envase
      agrupadoPorPartida.forEach((element) => {
        const agrupadoPorProductoEnvaseProducto = [];
        const temp = [...element.items];

        while (temp.length > 0) {
          const producto = temp.find((f) => f.Articulo.TipoArticulo === 'Producto');
          const envase = temp.find((f) => f.Articulo.TipoArticulo === 'Envase');

          agrupadoPorProductoEnvaseProducto.push([producto, envase]);

          const indexP = temp.findIndex((f) => f.Articulo.Id === producto.Articulo.Id);
          temp.splice(indexP, 1);

          const indexE = temp.findIndex((f) => f.Articulo.Id === envase.Articulo.Id);
          temp.splice(indexE, 1);
        }
        resultadoFinal.push(agrupadoPorProductoEnvaseProducto);
      });

      this.paleAPesar = {
        Id: paleLeido.Id,
        NumeroSerie: paleLeido.NumeroSerie,
        CodigoBarrasPale: paleLeido.CodigoBarrasPale,
        FechaFabricacion: paleLeido.FechaFabricacion,
        Existencias: resultadoFinal,
      };
    },

    GetTitle(pale, linea) {
      Log(this, this.GetTitle.name);
      const idArticulo = linea.Articulo.Id;
      const result = pale.Existencias.filter((f) => f.Articulo.Id === idArticulo);

      if (result === null) {
        return '';
      }
      return result[0].Articulo.Nombre;
    },
    GetSubtitle(pale) {
      Log(this, this.GetSubtitle.name);
      const result = pale.Existencias.filter((f) => f.Articulo.TipoArticulo === 'Envase');

      if (result === null) {
        return '';
      }
      return result[0].Articulo.Nombre;
    },
    EventOpenCodeSearch() {
      Log(this, this.EventOpenCodeSearch.name);
      this.$refs.componentUCcodeScanner.Open();
      this.numeroEnvasesTotal = 0;
      this.pesoBrutoTotal = 0;
    },

    UpdateData() {
      Log(this, this.UpdateData.name);
      this.numeroEnvasesTotal = 0;
      this.pesoBrutoTotal = 0;
      this.actionsWeighingReading = false;
      if (this.paleAPesar.CodigoBarrasPale) {
        this.BarCodeReadingEvent(this.paleAPesar.CodigoBarrasPale);
      } else {
        this.EventNumeroSerieReading(this.paleAPesar.NumeroSerie);
      }
    },

    // ***************************************** CONEXIONES ****************************************** \\
    async BarCodeReadingEvent(code) {
      Log(this, this.BarCodeReadingEvent.name);
      let paleLeido = null;

      const preloaderText = this.$t('codeScanner.info.validatingBarcode');
      const cancellationText = this.$t('codeScanner.info.validationCanceled');
      PreloaderGH(true, true, preloaderText, cancellationText);

      const result = await ConexionTA.callObtenePalePorCodigoDeBarras(code, true, true, true);
      if (result.Valor) {
        paleLeido = JSON.parse(result.Mensaje);
        if (paleLeido.Existencias.length === 0) {
          HiNotification.Alert('El número de serie indicado no está en existencias.', this.$t('common.error'));
          PreloaderGH(false);
          return;
        }
        this.CalculateContainersAndTotalGrossWeight(paleLeido.Existencias);
        this.FilterArray(paleLeido);
        PreloaderGH(false);
      } else {
        PreloaderGH(false);
        HiNotification.Alert(result.Mensaje, this.$t('common.error'));
        LogError(this, this.BarCodeReadingEvent.name, result.Mensaje);
      }
    },

    async EventNumeroSerieReading(code) {
      Log(this, this.EventNumeroSerieReading.name);
      let paleLeido = null;

      const preloaderText = this.$t('codeScanner.info.validatingSerialNumber');
      const cancellationText = this.$t('codeScanner.info.validationCanceled');
      PreloaderGH(true, true, preloaderText, cancellationText);

      const result = await ConexionTA.callObtenePalePorNumeroDeSerie(code, true, false, false);
      PreloaderGH(false);
      if (result.Valor) {
        paleLeido = JSON.parse(result.Mensaje);
        if (paleLeido.Existencias.length === 0) {
          HiNotification.Alert(this.$t('production.weighingSystem.readSerialNumber.notInStock'), this.$t('common.error'));
          return;
        }
        this.CalculateContainersAndTotalGrossWeight(paleLeido.Existencias);
        this.FilterArray(paleLeido);
      } else {
        HiNotification.Alert(result.Mensaje, this.$t('common.error'));
        LogError(this, this.BarCodeReadingEvent.name, result.Mensaje);
      }
    },

    async PrintPalletLabel() {
      Log(this, this.PrintPalletLabel.name);
      HiDialog.Preloader(true, this.$t('production.weighingSystem.printLabel.preloaderText'));
      const idANS = this.paleAPesar.Id;
      const result = await ConexionTA.callPrintPalletLabel(idANS);
      HiDialog.Preloader(false);
      if (!result.Valor) {
        HiNotification.Alert(result.Mensaje, this.$t('common.error'));
        LogError(this, this.PrintPalletLabel.name, result.Mensaje);
      }
    },
  },
};
</script>

<style lang="scss">
// TODO: Remove when migrated to new styles
.escanerCodigoBarras-popup {
  --code-scanner-bg-color: var(--his-slate-blue);
}

.main-weighing-system {
  .content-data {
    height: calc(100% - 80px);
  }

  .content-nodata {
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    align-items: center;
    margin-top: 15vh;

    div {
      max-width: 195px;
    }

    &__title {
      color: var(--his-darkgray);
      font-weight: 500;
      font-size: 18px;
    }

    &__text {
      color: var(--his-ash-gray);
      font-size: 14px;
      font-weight: 300;
      margin-top: 10px;
    }
  }

  .content-main-data {
    background: var(--his-sky-mist);
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-column-gap: 5px;

    &__data {
      display: flex;
      flex-direction: column;

      .content-title {
        color: var(--his-steel-blue);
        font-size: 12px;
        text-transform: uppercase;
      }

      .content-subtitle {
        color: var(--his-slate-blue);
        font-size: 18px;
        font-weight: 600;
      }
    }
  }

  .content-data-list {
    .item-title {
      color: var(--his-slate-blue);
      font-weight: 600;
      font-size: 18px;
      margin-bottom: 5px;
    }

    .item-subtitle {
      color: var(--his-steel-blue);
    }

    .content-list-logistic {
      color: var(--his-steel-blue);
      margin-top: 7px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      &__number {
        padding: 0 5px;
        color: var(--his-slate-blue);
        font-size: 18px;
        font-weight: 600;
      }
    }
  }

  .content-button {
    display: flex;
    justify-content: center;

    &__weighing {
      background-color: var(--his-mandarina);
      min-width: 200px;
      height: 58px;
      border-radius: calc(var(--f7-fab-size) / 2);
      position: relative;
      overflow: hidden;
      z-index: 1;
    }
  }
}
</style>
